

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETPLANBYID= createAsyncThunk(
  "getPlanById/getPlanById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getPlanByIdSlice = createSlice({
  name: "getPlanByIdSlice",
  initialState: {
    getPlanById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetPlanById: (state) => {
        state.getPlanById.loading = false
        state.getPlanById.error = false
        state.getPlanById.data = []
        state.getPlanById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETPLANBYID.fulfilled, (state, action) => {
      state.getPlanById = {
        ...state.getPlanById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPLANBYID.pending, (state, action) => {
      state.getPlanById = {
        ...state.getPlanById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETPLANBYID.rejected, (state, action) => {
      state.getPlanById = {
        ...state.getPlanById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getPlanByIdAction = {
    GETPLANBYID,
};

export { getPlanByIdAction };
export default getPlanByIdSlice.reducer;
export const {setInitialStateOfgetPlanById} = getPlanByIdSlice.actions
